import config from '../services/config';
export var outsideParty = function outsideParty(siteApi, getToken) {
  return {
    photoUrl: function photoUrl(id) {
      return "".concat(config.api.url, "/visitor/photo/").concat(id, "?token=").concat(getToken().accessToken, "&r=").concat(new Date());
    }
  };
};